import React from 'react'
import pencil from '../images/pencil.png'
import Topheader from './Topheader'
import Mainmenu from './Mainmenu'

export default function Noteswritten() {
  return (
    <>
  
    <div className="text-center flex gap-2 justify-center">
  <div className="text-3xl font-bold text-cuscolor-light mt-5">
  विद्यार्थीको सम्पत्ति 

  </div>
  <div>
    <img src={pencil}alt="pencil" className='h-10 w-10 mt-3' />
  </div>

 
  
</div>

    </>
  )
}
